async function devtricker_main_saveCurrentEditingPost() {
    try {

        const path = window.location.pathname;
        const segments = path.split('/');
        let postId = segments[2] || 0;

        let contentWrapper = document.querySelector(".content-wrapper");
        let lang = "und";

        if (contentWrapper) {
            lang = contentWrapper.getAttribute("lang");
        }

        //If postId == 0 save an empty post first; It's importante because is necessary upload images and associate to a post
        //before send the post whith the base64 image replaced by URL.
        if (postId == 0) {
            const data_result = await devtricker_main_createEmptyPost();
            postId = data_result.data.post_id;

            history.pushState({ page: 'edit' }, 'Edit Post', `/post/${postId}/edit/`);
            console.log(data_result);
        }

        const titleElement = document.querySelector('#johannesEditor .content-wrapper .title h1');
        const title = titleElement ? titleElement.innerText : '';

        const contentElements = document.querySelectorAll('#johannesEditor .content-wrapper .content .block');
        let content = '';

        contentElements.forEach(element => {
            const clonedElement = element.cloneNode(true);

            const elementsToRemove = clonedElement.querySelectorAll('.editor-only');
            elementsToRemove.forEach(el => el.remove());

            const contentEditableElements = clonedElement.querySelectorAll('[contentEditable="true"]');
            contentEditableElements.forEach(el => el.removeAttribute('contentEditable'));

            content += `<!-- wp:html -->\n${clonedElement.outerHTML}\n<!-- /wp:html -->\n`;
        });

        return await devtricker_ajax_upsert_postage(postId, title, content, lang);

    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR);
        throw error;
    }
}

async function devtricker_main_createEmptyPost() {
    const title = "";
    let content = " ";

    const path = window.location.pathname;
    const segments = path.split('/');
    const postId = segments[2] || 0;

    if (postId !== 0) {
        return;
    }

    let contentWrapper = document.querySelector(".content-wrapper");
    let lang = "und";

    if (contentWrapper) {
        lang = contentWrapper.getAttribute("lang");
    }

    try {
        return await devtricker_ajax_upsert_postage(postId, title, content, lang);
    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR);
        throw error;
    }
}

document.addEventListener('imageUploaded', async function (event) {

    const percentageText = document.createElement('span');
    percentageText.classList.add("image-upload-progress");

    try {
        const file = event.detail.file;

        const reader = new FileReader();

        reader.onload = async function (e) {
            const base64Src = e.target.result;

            const images = document.querySelectorAll("#johannesEditor img");
            for (const image of images) {
                if (image.src === base64Src) {
                    const loadingOverlay = document.createElement('div');
                    loadingOverlay.style.position = 'absolute';
                    loadingOverlay.style.bottom = '0';
                    loadingOverlay.style.right = '0';
                    loadingOverlay.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
                    loadingOverlay.style.color = '#d3d3d3';
                    loadingOverlay.style.padding = '5px';
                    loadingOverlay.style.borderTopLeftRadius = '5px';
                    loadingOverlay.style.display = 'flex';
                    loadingOverlay.style.alignItems = 'center';
                    loadingOverlay.style.zIndex = '10';
                    loadingOverlay.style.width = 'auto';

                    const spinner = document.createElement('div');
                    spinner.classList.add('spinner-border', 'spinner-border-sm');
                    spinner.setAttribute('role', 'status');
                    spinner.style.marginRight = '5px';

                    percentageText.textContent = '0%';

                    loadingOverlay.appendChild(spinner);
                    loadingOverlay.appendChild(percentageText);

                    const imageWrapper = document.createElement('div');
                    imageWrapper.style.position = 'relative';
                    imageWrapper.style.display = 'inline-block';

                    image.parentElement.insertBefore(imageWrapper, image);
                    imageWrapper.appendChild(image);

                    imageWrapper.appendChild(loadingOverlay);

                    let percentage = 0;
                    const interval = setInterval(() => {
                        // Check if an error has occurred
                        if (percentageText.errorOccurred) {
                            clearInterval(interval);
                            return;
                        }

                        percentage += 10;
                        if (percentage > 100) percentage = 100;
                        percentageText.textContent = `${percentage}%`;

                        if (percentage === 100) {
                            clearInterval(interval);
                        }
                    }, 200);

                    try {
                        const newUrl = await devtricker_post_uploadImage(file);

                        image.src = newUrl;

                        clearInterval(interval);
                        loadingOverlay.remove();

                        if (!g_post_editor_isPublished) {
                            await saveChanges();
                        }
                    } catch (error) {
                        // Clear the interval if an error occurs
                        clearInterval(interval);
                        console.error("Failed to upload image:", error);
                    }

                    break;
                }
            }
        };

        reader.readAsDataURL(file);
    } catch (error) {
        console.error("Failed to upload image:", error);
    }
});


document.addEventListener("EditorContentLoaded", () => {

    const contentWrapper = document.querySelector('.content-wrapper');

    if (contentWrapper) {
        const getTextContent = () => {
            return Array.from(contentWrapper.querySelectorAll('[contenteditable="true"]'))
                .filter(element => !element.closest('code, pre'))
                .map(element => element.textContent)
                .join(' ');
        };

        const debounce = (func, wait) => {
            let timeout;
            return function executedFunction(...args) {
                const later = () => {
                    clearTimeout(timeout);
                    func(...args);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };
        };

        const detectLanguageAndUpdateLang = debounce(() => {
            const textContent = getTextContent();
            if (textContent.trim().length > 0) {
                const languageCode6393 = franc.franc(textContent);
                const languageCode6391 = devtricker_tryGetIso6391From6392(languageCode6393);

                const element = document.querySelector(".content-wrapper");
                element.setAttribute('lang', languageCode6391);
            }
        }, 500);

        detectLanguageAndUpdateLang();

        contentWrapper.addEventListener('input', detectLanguageAndUpdateLang);
    }
});